import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "../components/Layout";

const SuccessQuestion = () => {
  const navigate = useNavigate();

  // The page stays static so the client clearly sees the booking is complete.
  // (Previously auto-redirected to "/" after 2s — removed per Nanna's feedback 2026-06-20.)
  return (
    <Container>
      <Card style={{ textAlign: "center", padding: "25px" }}>
        <h1>🎉 Booking gennemført!</h1>
        <p style={{ fontSize: "18px", marginTop: "15px", lineHeight: "1.5" }}>
          Tak! Din booking er bekræftet, og du modtager en bekræftelse på e-mail.
        </p>
        <div style={{ marginTop: "25px" }}>
          <button
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#018D66",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={() => navigate("/")}
          >
            Tilbage til forsiden
          </button>
        </div>
      </Card>
    </Container>
  );
};

export default SuccessQuestion;
